const bytesToSize = function (bytes) {
  if (bytes === 0) return '0 B'
  if (bytes === '') return '-'
  var k = 1024
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var i = Math.floor(Math.log(bytes) / Math.log(k))
  return (bytes / Math.pow(k, i)).toPrecision(3) + sizes[i]
}
const formaTime = function (val) {
  if (val !== '' || undefined || null) {
    return new Date(val).format('yyyy-MM-dd HH:mm')
  } else {
    return '永久有效'
  }
}
const sliceType = function (val, num) {
  if (val !== '' || undefined) {
    var point = val.lastIndexOf('.')
    var type = val.substring(point + 1).toLowerCase()
    if (this.isDir === 1) {
      return 'dir'
    }
    if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
      return 'pic'
    } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
      return 'video'
    } else if (this.isDir === 1) {
      return 'dir'
    } else if (type === 'txt') {
      return 'txt'
    } else if (type === 'pdf') {
      return 'pdf'
    } else if (type === 'doc' || type === 'docx') {
      return 'word'
    } else if (type === 'ppt' || type === 'pptx') {
      return 'ppt'
    } else if (type === 'xls' || type === 'xlsx') {
      return 'excel'
    } else if (type === 'html' || type === 'htm') {
      return 'html'
    } else if (type === 'wps' || type === 'wpt') {
      return 'wps'
    } else if (type === 'zip' || type === 'rar') {
      return 'package'
    } else {
      return 'default'
    }
  }
}

const GetQueryString = function (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

const sliceName = function (val, le) {
  if (val.length > le) {
    return val.substring(0, le / 2) + '...' + val.substring(val.length - le / 2)
  } else {
    return val
  }
}

export {
  bytesToSize,
  formaTime,
  sliceType,
  GetQueryString,
  sliceName
}



// WEBPACK FOOTER //
// ./src/assets/js/tools.js